
        import 'PaediatricSelector.a3cc07e.css-module'
        export default {"PaediatricSelector":"PaediatricSelector_PaediatricSelector_a3cc07e"}
    